import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { PlannedCourse } from '../../../../global/builders/planned_course_builder';
import { PlannedCourseGroup } from '../../../../global/builders/planned_course_group_builder';
import { PlannedTerm } from '../../../../global/builders/planned_term_builder';

export interface ITermPreview {
  planned_courses: PlannedCourse[];
  student_planned_terms: PlannedTerm[];
  planned_course_groups: PlannedCourseGroup[];
}

export type PreviewTermPlanModel = ITypedModel<ITermPreview>;

angular.module('capability-ng-academic-planner').factory(
  'ngPreviewTermPlanModel',
  () =>
    new Model<ITermPreview>({
      planned_courses: [],
      student_planned_terms: [],
      planned_course_groups: []
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/models/preview_term_plan_model.ts